import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import TaskStatus from "../../Tasks/TaskStatus";
import ProjectsTaskCk from "./ProjectTasksCk";
import {getProjectTasksByProjectId, updateTasks} from "../../../api";
import InvalidDataConfirm from "../../../components/ConfirmPopUp";
import {spinnerOff, spinnerOn} from "../../../components/Spinner";

class TasksContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checklist: " ",
            tasks: {},
            taskList: {},
            projectTasks: {},

        }
    }


    async componentDidMount() {
        spinnerOn();
        this.getProTasks();
        spinnerOff();
    }


    render() {
        const {checklist, taskList} = this.state;
        const {project,status,currentSection} = this.props;
        return (
            <ProjectsTaskCk
                sectionName={checklist}
                onSignEvent={(task) => this.updateTaskStatus(TaskStatus.SIGNED, task)}
                onRequestSignEvent={(task) => this.updateTaskStatus(TaskStatus.REQUESTED, task)}
                onMarkNaEvent={(task) => this.updateTaskStatus(TaskStatus.NA, task)}
                onMarkTempEvent={(task) => this.updateTaskStatus(TaskStatus.TEMPORARY, task)}
                onUndoEvent={(task) => this.updateTaskStatus(TaskStatus.UNDO, task)}
                projectStatus={project.projectStatus}
                taskList={taskList}
                project={project}
                status={status}
                projectValue={project}
            />
        )
    }
    async getProTasks() {
        spinnerOn();
        const {checklist} = this.props.match.params;
        const taskResponse = await getProjectTasksByProjectId(this.props.project.id);
        let projectTasks = taskResponse.projectTasks;
        this.setState({projectTasks,checklist});
        let taskList = {};
        if(projectTasks) {
            taskList = projectTasks[checklist];
            this.setState({taskList})
        }
        spinnerOff();
    }


    async updateTaskStatus(statusId, tasks) {
        try {
            const updatedTask = tasks.map(task => ({ ...task, ...{ statusId }}));
            const projectTasksStatus = await updateTasks(updatedTask);

            if(projectTasksStatus.updated === true){
                InvalidDataConfirm();
            }
        this.getProTasks();
        } catch (err) {
            console.log(err)
        }
    }
}
export default withRouter(TasksContainer);
